import React from 'react'
import './AboutMe.css'



function AboutMe() {
  React.useEffect(() => {
    const img = new Image();
    img.src = "/images/Profile_Hover.jpg"; // preload hover image
  }, []);
  return (
    <>
      <section id="about" style={{ scrollSnapAlign: 'start' }}>
        <div className="about-me">
          <h1>./About_Me</h1>
          <div className="center_align">
            <div className="about-me-contents">
              <div className="left-section">
                <img
                  src="/images/Profile.jpg"
                  alt="profile"
                  onMouseEnter={(e) => (e.currentTarget.src = "/images/Profile_Hover.jpg")}
                  onMouseLeave={(e) => (e.currentTarget.src = "/images/Profile.jpg")}
                />
              </div>

              <div className="right-section">
                Hi There! <img src="https://media.giphy.com/media/hvRJCLFzcasrR4ia7z/giphy.gif" width="20px" alt="hi" /><br /><br />

                My name is Soumyajit, and I’m a Software Engineer with a deep passion for technology and problem-solving.
                My expertise spans Python, Go, Network Automation, Time Synchronization and AI-driven solutions, including RAG, Vector Databases, and LangChain.
                I thrive on continuously learning, experimenting, and keeping up with the latest advancements to stay at the forefront of the field.
                Beyond my core work, I enjoy taking on side projects that let me flex both my creative and engineering muscles, pushing me to build meaningful and innovative solutions. <br /><br />

                Outside of engineering, I love exploring the world around me — whether it’s driving along new trails on my bike, sightseeing, or discovering places that fuel my curiosity and sense of adventure.
                I’m also a coffee enthusiast, always experimenting with different brewing methods like the V60, AeroPress, and moka pot in search of that perfect cup.


                <br /><br />
                Here are some technologies I’ve been working with
                <ul className="skills-list">
                  {/* Backend & Languages */}
                  <li><i class="fa-brands fa-python"></i> Python</li>
                  <li><i class="fa-brands fa-golang"></i> Go</li>
                  <li><i class="fa-brands fa-js"></i> JavaScript</li>

                  <li><i class="fa-solid fa-brain"></i> RAG</li>
                  <li><i class="fa-solid fa-robot"></i> Vector DB</li>
                  <li><i class="fa-solid fa-network-wired"></i> LangChain</li>

                  {/* Cloud & Databases */}
                  <li><i class="fa-solid fa-database"></i> PostgreSQL</li>
                  <li><i class="fa-solid fa-database"></i> Redis</li>
                  {/* Frontend */}
                  <li><i class="fa-brands fa-react"></i> React</li>
                  {/* DevOps & Infrastructure */}
                  <li><i class="fa-solid fa-dharmachakra"></i> Kubernetes</li>
                  <li><i class="fa-brands fa-docker"></i> Docker</li>
                  <li><i class="fa-brands fa-jenkins"></i> Jenkins</li>


                </ul>

              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AboutMe